import { STATS } from "../lib/site";

export const Stats = () => (
  <section data-testid="stats" className="relative py-20">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-xl overflow-hidden border border-white/10">
        {STATS.map((s, i) => (
          <div key={s.label} data-testid={`stat-${i}`} className="bg-ink-900 p-7 lg:p-10 hover:bg-ink-800 transition group">
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-cyan-400 mb-3">
              0{i + 1}
            </div>
            <div className="font-display font-extrabold text-white text-4xl lg:text-5xl tracking-tighter mb-2 group-hover:text-gradient-cyan transition">
              {s.value}
            </div>
            <div className="text-sm text-slate-400">{s.label}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
